import { Box } from '@mui/material';

import ApplicationSearchInput from '../../Common/ApplicationSearchInput';
import FilterSelect from '../../Common/FilterSelect';
import {
  ALL_VERDICT_FALSE_FILTER_OPTIONS,
  CENTER_FILTER_OPTIONS,
  CHANGE_DETECTION_FILTER_OPTIONS,
  DATA_EXTRACTED_FILTER_OPTIONS,
  ESCALATED_STATUS_FILTER_OPTIONS,
  EXTRACTION_QC_STATUS_FILTER_OPTIONS,
  QC_STATUS_FILTER_OPTIONS
} from '../constants';
import styles from '../styles';
import {
  SnapshotComparisonFilters as SnapshotComparisonFilterValues,
  CenterFilter,
  ExtractionQcStatusFilter,
  TriStateFilter
} from '../types';

/* eslint-disable no-unused-vars */
type SnapshotComparisonFiltersProps = {
  filters: SnapshotComparisonFilterValues;
  onCenterChange: (value: CenterFilter) => void;
  onQcStatusChange: (value: TriStateFilter) => void;
  onChangeDetectionStatusChange: (value: TriStateFilter) => void;
  onEscalatedStatusChange: (value: TriStateFilter) => void;
  onAllVerdictFalseChange: (value: TriStateFilter) => void;
  onExtractionQcStatusChange: (value: ExtractionQcStatusFilter) => void;
  onDataExtractedChange: (value: TriStateFilter) => void;
  onApplicationNumberSearch: (value: string) => void;
  onClear: () => void;
};
/* eslint-enable no-unused-vars */

const SnapshotComparisonFilters = ({
  filters,
  onCenterChange,
  onQcStatusChange,
  onChangeDetectionStatusChange,
  onEscalatedStatusChange,
  onAllVerdictFalseChange,
  onExtractionQcStatusChange,
  onDataExtractedChange,
  onApplicationNumberSearch,
  onClear
}: SnapshotComparisonFiltersProps) => {
  return (
    <Box sx={styles.filters}>
      <FilterSelect
        label='Center'
        value={filters.center}
        options={CENTER_FILTER_OPTIONS}
        onChange={value => onCenterChange(value as CenterFilter)}
      />
      <FilterSelect
        label='Curation Status'
        value={filters.qcStatus}
        options={QC_STATUS_FILTER_OPTIONS}
        onChange={value => onQcStatusChange(value as TriStateFilter)}
      />
      <FilterSelect
        label='Extraction Curation Status'
        value={filters.extractionQcStatus}
        options={EXTRACTION_QC_STATUS_FILTER_OPTIONS}
        onChange={value => onExtractionQcStatusChange(value as ExtractionQcStatusFilter)}
        minWidth={220}
      />
      <FilterSelect
        label='Data Extracted'
        value={filters.dataExtracted}
        options={DATA_EXTRACTED_FILTER_OPTIONS}
        onChange={value => onDataExtractedChange(value as TriStateFilter)}
      />
      <FilterSelect
        label='Changes Report (Available)'
        value={filters.changeDetectionStatus}
        options={CHANGE_DETECTION_FILTER_OPTIONS}
        onChange={value => onChangeDetectionStatusChange(value as TriStateFilter)}
      />
      <FilterSelect
        label='Escalated'
        value={filters.escalatedStatus}
        options={ESCALATED_STATUS_FILTER_OPTIONS}
        onChange={value => onEscalatedStatusChange(value as TriStateFilter)}
      />
      <FilterSelect
        label='All Verdict False'
        value={filters.allVerdictFalse}
        options={ALL_VERDICT_FALSE_FILTER_OPTIONS}
        onChange={value => onAllVerdictFalseChange(value as TriStateFilter)}
      />
      <ApplicationSearchInput
        value={filters.applicationNumber}
        onSearch={onApplicationNumberSearch}
        onClear={onClear}
      />
    </Box>
  );
};

export default SnapshotComparisonFilters;
